import { useEffect, useMemo, useState } from "react";

import { useLocation } from "react-router-dom";

import { ReportProps } from "..";
import { Filters } from "../../../../../../../models/shipeezi.table";
import { CronJobType } from "../../../../../../../util/enums";
import { getAllCurrentFilters, getTypeFromReportName } from "../utils";

const today = new Date();

export const useReportState = (useInitialDaterange?: boolean) => {
  const { state } = useLocation<ReportProps>();
  const { name: reportName } = state || {};
  const type: CronJobType = useMemo(() => {
    return getTypeFromReportName(reportName);
  }, [reportName]);
  const [filters, setFilters] = useState<Filters | undefined>({
    ...(useInitialDaterange
      ? {
          dateRange: [
            new Date(today.getFullYear(), today.getMonth(), 1),
            new Date(),
          ] as unknown as string[],
        }
      : {}),
  });

  const [tempFilters, setTempFilters] = useState<Filters | undefined>(filters ?? {});
  const [dateFilters, setDateFilters] = useState<Filters | undefined>({});
  const allCurrentFilters = useMemo(
    () => getAllCurrentFilters({ tempFilters: { ...filters, ...dateFilters }, reportName }),
    [reportName, tempFilters, dateFilters, filters]
  );

  useEffect(() => {
    if (state?.name) {
      setFilters(allCurrentFilters);
    }
  }, [state]);

  return {
    type,
    allCurrentFilters,
    dateFilters,
    filters,
    tempFilters,
    setFilters,
    setTempFilters,
    setDateFilters,
  };
};
